module.exports = __webpack_public_path__ + "static/media/natural-shine.6ce98d52.png";